import React, { useRef, useState, useEffect } from 'react';

import Api from "../api/Api.js";
import { Howl } from 'howler';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlay, faPause, faExpand , faCompress} from '@fortawesome/free-solid-svg-icons';
import { faVolumeUp, faVolumeMute } from '@fortawesome/free-solid-svg-icons';


import '../slider.css';

const TitleDiv = ({ title, desc, openPanel, selectable }) => {
  // 표시되는 내용이 title인지 desc인지를 추적하는 상태와,
  // 아이콘을 토글하는 상태를 정의합니다.
  const [isTitle, setIsTitle] = useState(true);
  const [icon, setIcon] = useState(faExpand); // 초기 아이콘 설정
  

  // 클릭 이벤트 핸들러: 내용과 아이콘을 토글합니다.
  const handleClick = () => {
    if (!selectable)return;

    if (openPanel(title) === false) {
      setIsTitle(!isTitle);
      setIcon(icon === faExpand ? faCompress : faExpand);
    }
  };

  if (title === "")return(<></>);
  return (
    <div
      style={{
      zIndex:100000,
      color: "black",
      position: 'absolute',
      top: 20,
      right: 40,
      margin: '10px',
      backgroundColor: 'rgba(255, 255, 255, 0.9)',
      padding: '20px 30px',
      fontSize: '1.3em',
      borderRadius: "5px",
      cursor: "pointer" // 커서를 포인터로 설정하여 클릭 가능함을 나타냅니다.
    }} onClick={handleClick}>
      {isTitle ? (<span  className='fw-bold text-dark'>{ title }</span>):(
       <div>
         <div className='fw-bold text-dark'>{title}</div>
         <div className='small text-dark'>{desc}</div>
         </div>) }
      {isTitle ? (
      <div style={{
        position: 'absolute',
        bottom: 0,
        left: 0,
        padding: '0px 5px',
        fontSize: '24px'
      }} className='d-none'>
        <FontAwesomeIcon icon={icon} color='gray' />
      </div>):(
         <div style={{
          position: 'absolute',
          top: 0,
          right: 0,
          padding: '0px 5px',
          fontSize: '24px'
        }} className='d-none'>
          <FontAwesomeIcon icon={icon} color='gray' />
        </div>
      )}

    </div>
  );
};


export default TitleDiv;
